import type { BusAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { AxleType } from "../AxleType.tsx";
import { BootSize } from "../BootSize.tsx";
import { Box } from "../Box.tsx";
import { CabinType } from "../CabinType.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { Engine } from "../Engine.tsx";
import { EuApproved } from "../EuApproved.tsx";
import { ExtraBrake } from "../ExtraBrake.tsx";
import { FirstRegistration } from "../FirstRegistration.tsx";
import { InteriorSize } from "../InteriorSize.tsx";
import { LengthCm } from "../LengthCm.tsx";
import { Make } from "../Make.tsx";
import { Mileage } from "../Mileage.tsx";
import { Model } from "../Model.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { NoOfSeats } from "../NoOfSeats.tsx";
import { RegistrationNumber } from "../RegistrationNumber.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { Suspension } from "../Suspension.tsx";
import { TailLift } from "../TailLift.tsx";
import { Transmission } from "../Transmission.tsx";
import { VehicleGroup } from "../VehicleGroup.tsx";
import { BusWeight } from "../Weight.tsx";
import { Wheelbase } from "../Wheelbase.tsx";

export const BusSpecifications = ({ ad }: { ad: BusAd }) => {
  return (
    <SpecificationsArea>
      <KeyInfo>
        {/*General information*/}
        <VehicleGroup segment={ad.type} />
        <ModelYear year={ad.year} />
        <Make make={ad.make} />
        <Model model={ad.model} />
        <Mileage distance={ad.mileage} unit={ad.mileage_unit} />
        <ChassisNumber chassisNumber={ad.chassis_number} />

        {/*Product properties*/}
        <LengthCm lengthCm={ad.length} />
        <Engine engine={ad.engine} />
        <Transmission transmission={ad.transmission} />
        <BootSize bootSize={ad.boot_size} />
        <BusWeight weight={ad.weight} />
        <AxleType axleType={ad.axle_type} />
        <Box box={ad.box} />
        <CabinType cabinType={ad.cabin_type} />
        <ExtraBrake extraBrake={ad.extra_brake} />
        <NoOfSeats noOfSeats={ad.no_of_seats} />
        <Suspension suspension={ad.suspension} />
        <TailLift tailLift={ad.tail_lift} />
        <Wheelbase wheelbase={ad.wheelbase} />

        {/*Appearance*/}
        <InteriorSize interiorSize={ad.interior_size} />

        {/*Registration, warranty, owners, etc*/}
        <EuApproved euApproved={ad.eu_approved} euApprovedDate={ad.eu_approved_date} />
        <RegistrationNumber registrationNumber={ad.registration_number} />
        <FirstRegistration firstRegistration={ad.first_registration} />
      </KeyInfo>
    </SpecificationsArea>
  );
};
